import { Select } from "@chakra-ui/react";
import { useState } from "react";

export const CustomCategorySelect = ({
  value,
  options,
  setBinStatusData,
  idx,
}) => {
  console.log(value);

  const handleChange = (value) => {
    console.log(value);
    setBinStatusData((prev) => {
      let updatedData = {
        ...prev,
        [idx]: {
          ...prev[idx],
          category: value,
        },
      };
      return updatedData;
    });
  };

  return (
    <Select
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      placeholder="Select Category"
      size={"sm"}
      rounded={"base"}
    >
      {options?.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </Select>
  );
};
